/** @jsx jsx */
import { css, jsx } from "@emotion/core";
import { useContext } from "react";
import { EditorContext } from "../../Context/EditorContext";

const Row = ({
  viewName,
  settingsName,
  inputExists,
  layoutExists,
  val,
  setVal,
  bg,
  cursorExists,
}) => {
  const {
    activeView,
    setActiveView,
    setIsOpened,
    layout,
    setLayout,
  } = useContext(EditorContext);

  return (
    <div
      onClick={() => {
        !inputExists && setActiveView(viewName);
        setIsOpened(false);
      }}
      css={styles}
      style={{
        flexDirection: layoutExists && "column",
        alignItems: layoutExists && "flex-start",
        background: bg,
        cursor: cursorExists ? "pointer" : "",
      }}
      className={viewName && (viewName === activeView ? "active" : "") + " row"}
    >
      {viewName && <p>{viewName}</p>}
      {settingsName && <p>{settingsName}</p>}
      {inputExists && (
        <input
          value={val}
          onChange={(e) => setVal(e.target.value)}
          type="text"
        />
      )}
      {layoutExists && (
        <div className="layout">
          <button
            style={{ background: layout === "Left" ? "#1d1e22" : "#4e5369" }}
            onClick={() => setLayout("Left")}
          >
            <i className="fas fa-align-left fa-lg"></i>
          </button>
          <button
            style={{ background: layout === "Right" ? "#1d1e22" : "#4e5369" }}
            onClick={() => setLayout("Right")}
          >
            <i className="fas fa-align-right fa-lg"></i>
          </button>
        </div>
      )}
    </div>
  );
};

const styles = css`
  width: 100%;
  padding: 14px;
  background: #1d1e22;
  display: flex;
  align-items: center;
  justify-content: space-between;
  &.active {
    background: #30364c;
  }
  p {
    color: #fff;
    font-size: 15px;
  }
  input {
    border: none;
    outline: none;
    padding: 10px;
  }
  .layout {
    width: 100%;
    padding: 14px 0 0 0;
    display: flex;
    justify-content: space-between;
    button {
      border: none;
      outline: none;
      padding: 0;
      height: 46px;
      width: 47%;
      cursor: pointer;
      display: flex;
      align-items: center;
      justify-content: center;
      background: #1d1e22;
      color: #fff;
    }
  }
`;

export default Row;
